/**
 * Selection Slice - Manages selected elements state
 * Handles single and multi-selection of nodes and edges
 */

import type { StateCreator } from 'zustand';
import type { WorkflowStore, SelectionSlice } from './types';

export const createSelectionSlice: StateCreator<WorkflowStore, [], [], SelectionSlice> = (set) => ({
  // Initial State
  selectedNodeId: null,
  selectedEdgeId: null,
  multiSelectedNodeIds: [],

  // Actions
  setSelectedNodeId: (nodeId) => {
    set({
      selectedNodeId: nodeId,
      selectedEdgeId: null, // Clear edge selection when selecting a node
      multiSelectedNodeIds: [] // Clear multi-selection
    });
  },

  setSelectedEdgeId: (edgeId) => {
    set({
      selectedEdgeId: edgeId,
      selectedNodeId: null, // Clear node selection when selecting an edge
      multiSelectedNodeIds: [] // Clear multi-selection
    });
  },

  setMultiSelectedNodeIds: (nodeIds) => {
    set({
      multiSelectedNodeIds: nodeIds,
      selectedNodeId: nodeIds.length === 1 ? nodeIds[0] : null,
      selectedEdgeId: null
    });
  },

  addToMultiSelection: (nodeId) => {
    set((state) => {
      const newIds = state.multiSelectedNodeIds.includes(nodeId) ? state.multiSelectedNodeIds : [...state.multiSelectedNodeIds, nodeId];
      return {
        multiSelectedNodeIds: newIds,
        selectedNodeId: newIds.length === 1 ? newIds[0] : null,
        selectedEdgeId: null
      };
    });
  },

  removeFromMultiSelection: (nodeId) => {
    set((state) => {
      const newIds = state.multiSelectedNodeIds.filter((id) => id !== nodeId);
      return {
        multiSelectedNodeIds: newIds,
        selectedNodeId: newIds.length === 1 ? newIds[0] : null
      };
    });
  },

  clearSelection: () => {
    set({
      selectedNodeId: null,
      selectedEdgeId: null,
      multiSelectedNodeIds: []
    });
  }
});
